import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { KEYWORD_SERVICE_PAGES, keywordServiceHead } from "@/lib/keywordServicePages";

export const Route = createFileRoute("/affordable-seo-small-business-colorado")({
  head: () => keywordServiceHead(KEYWORD_SERVICE_PAGES.smallBusinessSeo),
  component: () => <KeywordServiceLanding page={KEYWORD_SERVICE_PAGES.smallBusinessSeo} />,
});
